/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ConsentPayload interface.
 */
export function instanceOfConsentPayload(value) {
    if (!('marketing' in value) || value['marketing'] === undefined)
        return false;
    return true;
}
export function ConsentPayloadFromJSON(json) {
    return ConsentPayloadFromJSONTyped(json, false);
}
export function ConsentPayloadFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'marketing': json['marketing'],
        'ts': json['ts'] == null ? undefined : (new Date(json['ts'])),
    };
}
export function ConsentPayloadToJSON(json) {
    return ConsentPayloadToJSONTyped(json, false);
}
export function ConsentPayloadToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'marketing': value['marketing'],
        'ts': value['ts'] == null ? value['ts'] : value['ts'].toISOString(),
    };
}
